import React from "react";
import PropTypes from "prop-types";

import "./popConfirmSnapshot.scss";

const PopConfirmSnapshot = ({ className }) => {
  return (
    <div className={`pop-confirm-snapshot ${className}`}>

        <div className="position-relative bg-secondary msg-box">
        <svg
          className="position-absolute top-50"
          width="6"
          height="12"
          viewBox="0 0 6 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 0L6 12L2.14569e-07 6L6 0Z" fill="#FF7A2A" />
        </svg>          
          <p className="text-white text-nowrap mb-0">Snapshot Taken</p>
        </div>

    </div>
  );
};

PopConfirmSnapshot.propTypes = {
  className: PropTypes.string,
};
export default PopConfirmSnapshot;
